import Vue from "vue";
import Router from "vue-router";
import wrap from "@/pages/wrap/index";
import axios from "axios";
import { apis } from "./../core/apis";
import * as appUtils from "./../core/appUtils";
import { constyjyp } from "./../core/constyjyp";

Vue.use(Router);

function loadView(view) {
    return () => import(`../pages${view}.vue`);
}

const router = new Router({
    mode: "history",
    base: "p",
    routes: [
        {
            path: "/project/:projectId/noticeList",
            name: "noticeList",
            component: loadView("/trainingProject/login/noticeList/index")
        },
        {
            path: "/project/noticeList/details",
            name: "details",
            component: loadView("/trainingProject/login/noticeList/details")
        },
        {
            path: "/project/:projectId",
            name: "prohome",
            meta: {
                title: "项目首页"
            },
            component: loadView("/trainingProject/login/index")
        },
        {
            path: "/home/record/gradeDetail",
            name: "gradeDetail",
            component: loadView("/home/record/gradeDetail/index")
        },
        {
            path: "/",
            name: "wrap",
            component: wrap,
            beforeEnter: function(to, from, next) {
                if (to.query && to.query.jti) {
                    appUtils.setLocalStorage(constyjyp.JTI, to.query.jti);
                    axios({
                        method: "get",
                        url: apis.api.home.checkToken + to.query.jti
                    })
                        .then(res => {
                            appUtils.removeLocalStorage(constyjyp.JTI);
                            console.log(res);
                            appUtils.setLocalStorage(
                                constyjyp.TOKEN_KEY,
                                res.data.access_token
                            );
                            res.data.data.jti = to.query.jti;
                            appUtils.setLocalStorage(
                                constyjyp.USER_INFO,
                                res.data.data
                            );
                            next();
                        })
                        .catch(err => {
                            console.log(err);
                            next();
                        });
                } else {
                    next();
                }
            },
            children: [
                {
                    path: "/",
                    // component: login,
                    component: loadView("/home/index"),
                    children: [
                        {
                            path: "",
                            // component: task,
                            component: loadView("/home/index/index")
                        }
                    ]
                },
                {
                    path: "/evaluationDetail",
                    name: "evaluationDetail",
                    component: loadView("/home/record/evaluationDetail/index")
                },
                {
                    path: "home",
                    // component: register,
                    component: loadView("/home/index"),
                    children: [
                        {
                            path: "/",
                            component: loadView("/home/index/index")
                        },
                        // 230208 花都特殊化
                        {
                            path: "/indexhd",
                            name: "indexhd",
                            component: loadView("/home/index/indexhd")
                        },
                        {
                            path: "/train",
                            component: loadView("/home/train/index")
                        },
                        {
                            path: "/record",
                            component: loadView("/home/record/index")
                        },
                        {
                            path: "/order",
                            component: loadView("/home/order/index")
                        },
                        {
                            path: "/sOrder",
                            component: loadView("/home/sOrder/index")
                        },
                        {
                            path: "/listApply",
                            component: loadView("/home/listApply/index")
                        },
                        {
                            path: "/myManage",
                            component: loadView("/home/myManage/index")
                        },
                        {
                            path: "/myCertificate",
                            component: loadView("/home/myCertificate/index")
                        },
                        {
                            path: "/applyDetail",
                            component: loadView(
                                "/home/listApply/applyDetail/index"
                            )
                        },
                        {
                            path: "/applyDetailreview",
                            component: loadView(
                                "/home/activitySelect/activitySelect/applyDetail/index"
                            )
                        },
                        {
                            path: "/applyDetail1",
                            component: loadView(
                                "/home/listApply2/applyDetail/index"
                            )
                        },
                        {
                            path: "/schoolBattleApplyDetail",
                            component: loadView(
                                "/home/schoolBattle/applyDetail/index"
                            )
                        },
                        {
                            path: "/listApply2",
                            component: loadView("/home/listApply2/index")
                        },
                        // 申请课题变更
                        {
                            path: "/applySubjectChange",
                            component: loadView("/home/applySubjectChange/index")
                        },
                        {
                            path: "/invoiceApply",
                            component: loadView("/home/invoice/index")
                        },
                        {
                            path: "/course",
                            component: loadView("/home/course/index")
                        },
                        {
                            path: "/detail",
                            component: loadView("/home/course/detail")
                        },
                        {
                            path: "/myexam",
                            component: loadView("/home/exam/index")
                        },
                        {
                            path: "/certificate",
                            component: loadView("/home/certificate/index")
                        },

                        // 区级培训-项目报读
                        {
                            path: "/projectTrain",
                            component: loadView(
                                "/home/districtLevelManagement/projectTrain/index"
                            )
                        },
                        {
                            path: "/training",
                            component: loadView(
                                "/home/districtLevelManagement/projectTrain/training"
                            )
                        },
                        {
                            path: "/selecting",
                            component: loadView(
                                "/home/districtLevelManagement/selecting/index"
                            )
                        },
                        {
                            path: "/groupSelecting",
                            component: loadView(
                                "/home/districtLevelManagement/groupSelecting/index"
                            )
                        },
                        // 校级管理-课程申报
                        {
                            path: "/trainDeclaration",
                            component: loadView(
                                "/home/schoolLevelManagement/trainDeclaration/index"
                            )
                        },
                        // 校级管理-课程申报-课程申报登记
                        {
                            path: "/addTrainDeclaration",
                            component: loadView(
                                "/home/schoolLevelManagement/trainDeclaration/addTrainDeclaration"
                            )
                        },
                        // 校本报读审核
                        {
                            path: "/audit",
                            component: loadView(
                                "/home/districtLevelManagement/audit/index"
                            )
                        },
                        // 校本报读审核
                        {
                            path: "/audit1",
                            component: loadView(
                                "/home/districtLevelManagement/audit1/index"
                            )
                        },
                        // 区级项目报读
                        {
                            path: "/distcourseEnrollment",
                            component: loadView(
                                "/home/schoolBasedTraining/distcourseEnrollment/index"
                            )
                        },
                        // 区级报读记录
                        {
                            path: "/distenrollmentRecords",
                            component: loadView(
                                "/home/schoolBasedTraining/distenrollmentRecords/index"
                            )
                        },
                        {
                            path: "/districtCourseApply",
                            component: loadView(
                                "/home/districtCourse/districtCourseApply/index"
                            )
                        },
                        {
                            path: "/districtCourseRecord",
                            component: loadView(
                                "/home/districtCourse/districtCourseRecord/index"
                            )
                        },
                        // 校级管理-课程申报-课程申报登记
                        {
                            path: "/districtCourseDetail",
                            component: loadView(
                                "/home/districtCourse/districtCourseApply/districtCourseDetail"
                            )
                        },
                        
                        {
                            path: "/districtTrain",
                            component: loadView(
                                "/home/districtTrain/districtTrain/index"
                            )
                        },
                        {
                            path: "/districtRecord",
                            component: loadView(
                                "/home/districtTrain/districtRecord/index"
                            )
                        },
                        
                        // {
                        //   path: '/achievement',
                        //   component: loadView('/home/achievement/index'),
                        // },
                        {
                            path: "/schCom",
                            component: loadView("/home/community/schCommunity")
                        },
                        {
                            path: "/regCom",
                            component: loadView("/home/community/regCommunity")
                        },
                        // 校本培训-项目报读
                        {
                            path: "/courseEnrollment",
                            component: loadView(
                                "/home/schoolBasedTraining/courseEnrollment/index"
                            )
                        },
                        // 校本培训-项目报读
                        {
                            path: "/activityEnrollment",
                            component: loadView(
                                "/home/schoolBattle/activityEnrollment/index"
                            )
                        },
                        // 校本培训-项目报读
                        {
                            path: "/activitySelect",
                            component: loadView(
                                "/home/activitySelect/activitySelect/index"
                            )
                        },
                        {
                            path: "/activitySelect1",
                            component: loadView(
                                "/home/activitySelect/activitySelect/index1"
                            )
                        },
                        // 校本培训-报读记录
                        {
                            path: "/activityRecords",
                            component: loadView(
                                "/home/schoolBattle/activityRecords/index"
                            )
                        },
                        // 校本培训-报读记录
                        {
                            path: "/enrollmentRecords",
                            component: loadView(
                                "/home/schoolBasedTraining/enrollmentRecords/index"
                            )
                        },
                        // 校级管理-课程申报
                        {
                            path: "/courseDeclaration",
                            component: loadView(
                                "/home/schoolLevelManagement/courseDeclaration/index"
                            )
                        },
                        // 校级管理-课程申报-课程申报登记
                        {
                            path: "/addCourseDeclaration",
                            component: loadView(
                                "/home/schoolLevelManagement/courseDeclaration/addCourseDeclaration"
                            )
                        },
                        // 校级管理-课程申报-上传过程材料
                        {
                            path: "/uploadProcessMaterials",
                            component: loadView(
                                "/home/schoolLevelManagement/courseDeclaration/uploadProcessMaterials"
                            )
                        },
                        // 校级管理-成绩管理
                        {
                            path: "/gradeManagement",
                            component: loadView(
                                "/home/schoolLevelManagement/gradeManagement/index"
                            )
                        },
                        // 校级管理-经费登记
                        {
                            path: "/fundsManagement",
                            component: loadView(
                                "/home/schoolLevelManagement/fundsManagement/index"
                            )
                        },
                        // 校级管理-经费登记-填报详情
                        {
                            path: "/fillInDetails",
                            component: loadView(
                                "/home/schoolLevelManagement/fundsManagement/fillInDetails"
                            )
                        },
                        // 校级管理-查询统计
                        {
                            path: "/queryStatistics",
                            component: loadView(
                                "/home/schoolLevelManagement/queryStatistics/index"
                            )
                        }
                    ]
                },
                {
                    path: "/problemDetail",
                    name: "problemDetail",
                    component: loadView("/home/listApply/problemDetail/index")
                },
                {
                    path: "setting",
                    // component: register,
                    component: loadView("/home/index"),
                    children: [
                        {
                            path: "",
                            // component: task,
                            component: loadView("/setting/index/index")
                        }
                    ]
                },
                {
                    path: "message",
                    // component: register,
                    component: loadView("/home/index"),
                    children: [
                        {
                            path: "",
                            // component: task,
                            component: loadView("/message/index/index")
                        }
                    ]
                }
                // {
                //   path: '*',
                //   // component: NotFoundComponent,
                //   component: loadView('404/404'),
                // }
            ]
        },
        {
            path: "/",
            name: "studyWrap",
            component: loadView("/wrap/study"),
            beforeEnter: function(to, from, next) {
                if (to.query && to.query.jti) {
                    appUtils.setLocalStorage(constyjyp.JTI, to.query.jti);
                    axios({
                        method: "get",
                        url: apis.api.home.checkToken + to.query.jti
                    })
                        .then(res => {
                            appUtils.removeLocalStorage(constyjyp.JTI);
                            console.log(res);
                            appUtils.setLocalStorage(
                                constyjyp.TOKEN_KEY,
                                res.data.access_token
                            );
                            appUtils.setLocalStorage(
                                constyjyp.USER_INFO,
                                res.data.data
                            );
                            next();
                        })
                        .catch(err => {
                            console.log(err);
                            next();
                        });
                } else {
                    next();
                }
            },
            children: [
                {
                    path: "study",
                    component: loadView("/home/train/study/index"),
                    children: [
                        {
                            path: "studySpace/:projectId",
                            component: loadView(
                                "/home/train/study/studySpace/index"
                            )
                        },
                        {
                            path: "chooseCourse/:projectId",
                            component: loadView(
                                "/home/train/study/chooseCourse/index"
                            )
                        },
                        {
                            path: "myLesson/:projectId",
                            component: loadView(
                                "/home/train/study/myLesson/index"
                            )
                        }
                    ]
                },
                {
                    path: "courseDetail/:id",
                    component: loadView("/home/train/study/courseDetail/index")
                }
            ]
        },
        {
            path: "/tempView",
            component: loadView("/tempView/tempView")
        },
        {
            path: "/login",
            name: "login",
            component: loadView("/login/Login")
        },
        {
            path: "/freezeNoApply",
            name: "freezeNoApply",
            component: loadView("/login/accountFreeze/freezeNoApply")
        },
        {
            path: "/freezeApplying",
            name: "freezeApplying",
            component: loadView("/login/accountFreeze/freezeApplying")
        },
        {
            path: "/resetPwd",
            name: "resetPwd",
            component: loadView("/login/forgetPassword/resetPwd")
        },
        {
            path: "/changePwd",
            name: "changePwd",
            component: loadView("/login/forgetPassword/changePwd")
        },
        {
            path: "/changePassWord",
            name: "changePassWord",
            component: loadView("/login/forgetPassword/changePassWord")
        },
        {
            path: "/changeEmail",
            name: "changeEmail",
            component: loadView("/login/forgetPassword/changeEmail")
        },
        {
            path: "/forgetPwd",
            name: "forgetPwd",
            component: loadView("/login/forgetPassword/forgetPwd")
        },
        {
            path: "/resetPwdByEmail",
            name: "resetPwdByEmail",
            component: loadView("/login/forgetPassword/resetPwdByEmail")
        },
        {
            path: "/register",
            name: "register",
            component: loadView("/login/register/register")
        },
        {
            path: "*",
            component: loadView("/404/index")
        },
    ]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : "个人中心";
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js